<style type="text/css" lang="scss">
  .right-dialog {
    .el-transfer-panel {
      width: 240px;
    }
    .el-transfer-panel__footer {
      height: 38px;
      clear: both;
    }
  }
  .transfer-footer {
    padding: 6px 5px;
  }
  .alert-txt {
    padding: 15px 0;
  }
  .delay-dialog {
    .el-textarea {
      width: 80%;
      vertical-align: middle;
    }
    .option-box {
      padding: 15px 0;
      .el-date-editor {
        width: 70%;
      }
    }
  }
</style>

<template>
  <div>
    <el-table :data="pointList" :height="wheight-150" v-loading="loading">
      <el-table-column label="变动" min-width="100">
        <template slot-scope="scope">
          <span v-if="0 == scope.row.outcome">增加</span>
          <span v-if="0 == scope.row.income">减少</span>
        </template>
      </el-table-column>
      <el-table-column v-if="" prop="income" label="积分" min-width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.income">{{scope.row.income}}</span>
          <span v-if="scope.row.outcome">{{scope.row.outcome}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="point_desc" label="记录" min-width="90"></el-table-column>
    </el-table>
    <div v-if="total_count > params.pageSize" class="content-padded content-center">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :total="total_count" :page-size="params.pageSize">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getMemberPoint } from '../../../../src/api/point'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      loading: false,
      activeName: 'point',
      total_count: 0,
      pointList: [],
      params: {
        page: 1,
        pageSize: 20,
        user_id: '',
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    handleCurrentChange() {
      this.getPointList()
    },
    getPointList () {
      this.loading = true
      getMemberPoint(this.params).then(response => {
        this.pointList = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
      })
    }
  },
  mounted () {
    this.getPointList()
    this.params.user_id = this.$route.query.user_id
  }
}
</script>



// WEBPACK FOOTER //
// pointlist.vue?3c215b9d